import React, { useState } from 'react';
import { FaTimes, FaDownload, FaExclamationTriangle } from 'react-icons/fa';

const DocumentViewerModal = ({ document: doc, onClose, onDownload }) => {
    if (!doc) return null;

    // Documents now arrive as a presigned S3 URL rather than an inline base64
    // data URI, and that response carries no MIME type — so infer it from the
    // filename. Falls back to doc.data for any caller still passing base64.
    const src = doc.url || doc.data;
    const ext = String(doc.name || '').split('.').pop().toLowerCase();
    const type = doc.type
        || (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext) ? `image/${ext}` : '')
        || (ext === 'pdf' ? 'application/pdf' : '');

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[70] p-4">
            <div className="bg-[#282828] rounded-xl max-w-5xl w-full h-[85vh] flex flex-col">
                <div className="p-4 border-b border-[#3c3836] flex-shrink-0 flex justify-between items-center">
                    <div>
                        <h2 className="text-xl font-bold text-[#ebdbb2]">{doc.name}</h2>
                        <p className="text-sm text-[#928374]">{type || 'file'}{doc.size ? ` • ${(doc.size / 1024).toFixed(1)} KB` : ''}</p>
                    </div>
                    <div className="flex items-center space-x-3">
                        <button
                            onClick={() => onDownload(doc)}
                            className="px-3 py-1.5 bg-[#fabd2f] text-[#1d2021] text-sm rounded hover:bg-[#fe8019] flex items-center gap-2"
                        >
                            <FaDownload /> Download
                        </button>
                        <button onClick={onClose} className="text-[#928374] hover:text-[#bdae93] p-2">
                            <FaTimes size={24} />
                        </button>
                    </div>
                </div>

                <div className="flex-1 bg-[#1d2021] p-4 overflow-hidden flex items-center justify-center relative">
                    {type && type.includes('image') ? (
                        <img
                            src={src}
                            alt="Document"
                            className="max-w-full max-h-full object-contain"
                        />
                    ) : type === 'application/pdf' ? (
                        <iframe
                            src={src}
                            title="PDF Viewer"
                            className="w-full h-full border-none bg-white"
                        />
                    ) : (
                        <div className="text-center">
                            <FaExclamationTriangle className="text-yellow-500 text-5xl mx-auto mb-4" />
                            <p className="text-[#ebdbb2] mb-2">Preview not available for this file type.</p>
                            <button
                                onClick={() => onDownload(doc)}
                                className="text-[#fabd2f] hover:underline"
                            >
                                Download to view
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DocumentViewerModal;
